import {Component, computed, input, signal} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FieldContainerComponent} from '@shared/form/field-container/field-container.component';
import {StringFieldBaseComponent} from '@shared/form/string/string-field-base.component';
import {CharsLeftComponent} from '@shared/form/string/chars-left/chars-left.component';
import {EyeIcon, EyeOffIcon, LucideAngularModule} from 'lucide-angular';
import {TranslocoDirective} from '@jsverse/transloco';

@Component({
  selector: 'app-password-field',
  imports: [
    ReactiveFormsModule,
    FieldContainerComponent,
    CharsLeftComponent,
    LucideAngularModule,
    TranslocoDirective
  ],
  templateUrl: './password-field.component.html',
  styleUrl: './password-field.component.scss'
})
export class PasswordFieldComponent extends StringFieldBaseComponent {

  public readonly charsLeftThreshold = input(5);
  public  readonly isBadCredentials = input(false);

  public readonly showPassword = signal(false);
  public readonly inputType = computed(() => this.showPassword() ? 'text' : 'password');

  public readonly icons = {
    show: EyeIcon,
    hide: EyeOffIcon
  };

  public toggleShowPassword(): void {
    this.showPassword.update(value => !value);
  }

}
